export const router = {
  dataOverView: '资产概览',
  assetsCenter: '资产中心',
  database: '数据库',
  categoryManagement: '类目管理',
  login: '登录',
  originalDatabase: '原始数据库',
  assetsCatalog: '资产目录',
  annotationDatabase: '标注数据库',
  formalDatabase: '正式数据库',
  contentsManage: '目录管理',
  tagsManage: '标签管理',
  editMarkdown: '编辑MD文档',
  metadata: '元数据',
  dataService: '数据服务',
  apiManagement: 'API管理',
  addApi: 'API服务新增',
  editApi: 'API服务编辑',
  detailApi: 'API服务详情',
  apiLog: '调用日志',
  apiMonitor: '监控',
  apiCategory: '数据服务类目',
  systemManagementRouter: '系统管理',
  userManagement: '用户管理',
  roleManagement: '角色管理',
  menuManagement: '菜单管理',
  departmentManagement: '部门管理',
  knowledgeBase: '知识库',
  integratedLibrary: '集成库',
  productRepository: '产品库',
  manufacturerSLibrary: '厂商库',
  dataDevelopment: '数据研发',
  dataSource: '数据源连接',
  connectTable: '关联表'
}
